var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"print-step1"},[_c('div',{staticClass:"checkin-wrap"},[_c('checkin-form',{on:{"callback":_vm.checkIn}})],1),_c('div',{staticClass:"rule-wrap"},[_c('rule')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }